import Admin from 'hive-admin';

const OriginalFieldCodeEditorCreator = Admin.getFromLibrary('FieldCodeEditor');

Admin.addToLibrary(
  'FieldCodeEditor',
  (config = {}) => OriginalFieldCodeEditorCreator({
    getMonacoEditorOptions: (props) => ({
      ...(props.monacoEditorOptions || {}),
      scrollBeyondLastLine: false,
      scrollbar: {
        alwaysConsumeMouseWheel: false,
      },
      minimap: {
        enabled: false,
      },
      // TODO - Editor lines are wrapped
      // wordBreak: 'normal',
      // wordWrap: true,
      // wordWrapBreakAfterCharacters: ' :',
      // wordWrapBreakBeforeCharacters: '.',
      // wrappingIndent: 'indent',
      contextmenu: false,
      tabSize: 2,
      insertSpaces: true,
      detectIndentation: false,
      // lineNumbers: 'off',
      glyphMargin: false,
      folding: false,
      // Undocumented see https://github.com/Microsoft/vscode/issues/30795#issuecomment-410998882
      // lineDecorationsWidth: 0,
      lineNumbersMinChars: 4,
    }),
    onMount: (_, monaco) => {
      monaco.editor.defineTheme('packman', {
        base: 'vs-dark',
        inherit: true,
        rules: [],
        colors: {
          'editor.foreground': '#ffffff',
          'editor.background': '#282a36',
          'editor.selectionBackground': '#ffffff11',
          'editor.lineHighlightBackground': '#ffffff11',
          'editorCursor.foreground': '#ffffff',
          'editorIndentGuide.activeBackground': '#ffffff55',
        },
      });
      monaco.editor.setTheme('packman');
      setTimeout(() => {
        monaco.editor.setTheme('packman');
      }, 1);
    },
    ...config,
  }),
);
